// Import Firebase SDK functions
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import EventBus from '@/libs/eventBus';
import api from '@/libs/api.js';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBVkMm_FMtJScFWJsD65g7rxEXQfn0pqLk",
    authDomain: "vue3-firebase-583db.firebaseapp.com",
    projectId: "vue3-firebase-583db",
    storageBucket: "vue3-firebase-583db.firebasestorage.app",
    messagingSenderId: "819400158463",
    appId: "1:819400158463:web:08f141aedf5c31892070ca",
    measurementId: "G-RXGVEJEY6G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
let messaging;

// Kiểm tra trình duyệt có hỗ trợ các tính năng cần thiết
if ('serviceWorker' in navigator && 'Notification' in window) {
    try {
        console.log('đã khởi tạo firebase');
        messaging = getMessaging(app);
    } catch (error) {
        console.error('Lỗi khi khởi tạo Firebase Messaging:', error);
    }
} else {
    console.error('Trình duyệt không hỗ trợ Service Worker hoặc Notification API.');
}

// Hàm yêu cầu quyền thông báo và lấy token Firebase
export async function requestNotificationPermission() {
    if (!messaging) {
        console.error('Firebase Messaging chưa được khởi tạo.');
        return null;
    }

   try {
        const currentToken = await getToken(messaging, {
          vapidKey: "BEJNsEL2Q-15d3ut2AUwJXMt0YI-zpisYybEjZ3EBIk6xcd3Scm05w8YSrVfJO6a2pROpFUu2xjlGqHVrceQkxM",
        });

        if (currentToken) {
          const response = await api.post("/users/create-fcm-token", {
            fcm_token: currentToken,
          });
          return response;
        } else {
          console.log("No registration token available. Request permission to generate one.");
        }
      } catch (err) {
        console.error("An error occurred while retrieving token. ", err);
      }
}

// Xử lý thông báo khi ứng dụng đang hoạt động
if (messaging) {
    onMessage(messaging, (payload) => {
        const { title, body } = payload.notification || {};
        // EventBus.emit('show-notification', JSON.stringify({
        //     id: '',
        //     title: "Thông báo",
        //     message: payload.notification.title,
        //     url: '',
        //     type: 'info',
        //     showtime: 2000
        // }));
        EventBus.emit('show-notification', JSON.stringify({
            id: '',
            title: title || 'Thông báo',
            message: body || 'Bạn có thông báo mới.',
            url: '',
            type: 'info',
            showtime: 2000
        }));
    });
}

export { messaging };
